import { useCallback } from 'react';
import { useTooltip } from '../components/TooltipProvider';

export const useTooltipEvents = (content: string, disabled = false) => {
  const { showTooltip, hideTooltip, updatePosition } = useTooltip();

  const handleMouseEnter = useCallback((e: React.MouseEvent) => {
    if (disabled || !content) return;
    showTooltip(content, e.clientX, e.clientY);
  }, [content, disabled, showTooltip]);

  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    if (disabled || !content) return;
    updatePosition(e.clientX, e.clientY);
  }, [content, disabled, updatePosition]);

  const handleMouseLeave = useCallback(() => {
    hideTooltip();
  }, [hideTooltip]);

  return {
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
  };
};
